import { defineAsyncComponent } from 'vue'

export const questions = {
  Borrowers: defineAsyncComponent(() => import('./BorrowersQuestion.vue')),
  CollateralType: defineAsyncComponent(() => import('./CollateralTypeQuestion.vue')),
  NewProduction: defineAsyncComponent(() => import('./NewProductionQuestion.vue')),
  CollateralAddress: defineAsyncComponent(() => import('./CollateralAddressQuestion.vue')),
  CollateralValuation: defineAsyncComponent(() => import('./CollateralValuationQuestion.vue')),
  CollateralMonthlyFee: defineAsyncComponent(() => import('./CollateralMonthlyFeeQuestion.vue')),
  CollateralApartmentDetails: defineAsyncComponent(() => import('./CollateralApartmentDetailsQuestion.vue')),
  CollateralSize: defineAsyncComponent(() => import('./CollateralSizeQuestion.vue')),
  HomeInsurance: defineAsyncComponent(() => import('./HomeInsuranceQuestion.vue')),
  LoanAmount: defineAsyncComponent(() => import('./LoanAmountQuestion.vue')),
  HighPriority: defineAsyncComponent(() => import('./HighPriorityQuestion.vue')),
  BridgeLoan: defineAsyncComponent(() => import('./BridgeLoanQuestion.vue')),
  DepositLoan: defineAsyncComponent(() => import('./DepositLoanQuestion.vue')),
  CashContribution: defineAsyncComponent(() => import('./CashContributionQuestion.vue')),
  HouseholdChildren: defineAsyncComponent(() => import('./HouseholdChildrenQuestion.vue')),
  HouseholdCars: defineAsyncComponent(() => import('./HouseholdCarsQuestion.vue')),
  CapitalAssets: defineAsyncComponent(() => import('./CapitalAssetsQuestion.vue')),
  OtherLoans: defineAsyncComponent(() => import('./OtherLoansQuestion.vue')),
  OtherProperties: defineAsyncComponent(() => import('./OtherPropertiesQuestion.vue')),
  CommitmentPropertyType: defineAsyncComponent(() => import('./CommitmentPropertyTypeQuestion.vue')),
  CommitmentSize: defineAsyncComponent(() => import('./CommitmentSizeQuestion.vue')),
  CommitmentMonthlyFee: defineAsyncComponent(() => import('./CommitmentMonthlyFeeQuestion.vue')),
  CommitmentMunicipality: defineAsyncComponent(() => import('./CommitmentMunicipalityQuestion.vue')),
  TopupPurpose: defineAsyncComponent(() => import('./TopupPurposeQuestion.vue')),
  TopupPurposeOther: defineAsyncComponent(() => import('./TopupPurposeOtherQuestion.vue')),
  Comment: defineAsyncComponent(() => import('./CommentQuestion.vue')),
} as const

export type Question = keyof typeof questions
